import React from "react";

const EyeOpen = () => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_9275_1558)">
        <path
          d="M9 5.45455C11.7564 5.45455 14.2145 7.00364 15.4145 9.45455C14.2145 11.9055 11.7564 13.4545 9 13.4545C6.24364 13.4545 3.78545 11.9055 2.58545 9.45455C3.78545 7.00364 6.24364 5.45455 9 5.45455ZM9 4C5.36364 4 2.25818 6.26182 1 9.45455C2.25818 12.6473 5.36364 14.9091 9 14.9091C12.6364 14.9091 15.7418 12.6473 17 9.45455C15.7418 6.26182 12.6364 4 9 4ZM9 7.63636C10.0036 7.63636 10.8182 8.45091 10.8182 9.45455C10.8182 10.4582 10.0036 11.2727 9 11.2727C7.99636 11.2727 7.18182 10.4582 7.18182 9.45455C7.18182 8.45091 7.99636 7.63636 9 7.63636ZM9 6.18182C7.19636 6.18182 5.72727 7.65091 5.72727 9.45455C5.72727 11.2582 7.19636 12.7273 9 12.7273C10.8036 12.7273 12.2727 11.2582 12.2727 9.45455C12.2727 7.65091 10.8036 6.18182 9 6.18182Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_9275_1558">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EyeOpen;
